/* eslint-disable*/
import { useTheme } from '@mui/material';
import {
  Box,
  CircularProgress,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  List
} from '@material-ui/core';
import { currentchannelName } from 'feactures/channel/channelSlice';
import {
  fetchKeywordGraph,
  fetchKeywordList,
  performancereviewOtherDataLoading,
  performancereviewOwnDataLoading,
  performanceSeokeywordList,
  performanceSeoSetting,
  performanceSeoData,
  resetKeyword,
  setKeyword,
  fetchDeleteSeoKeyword
} from 'feactures/performancereview/performancereviewSlice';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SeoCompareLineGraph from './SeoCompareLineGraph';
import { errorResMessage, setError } from 'feactures/errorSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { userinfo } from 'feactures/user/userSlice';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import OKicon from 'components/atoms/icon/OKicon';
import NGicon from 'components/atoms/icon/NGicon';
import ResponsiveButton from 'components/atoms/button/ResponsiveButton';
import SeoKeywordRegisterDialog from 'components/atoms/modal/SeoKeywordRegisterDialog';
import FreePlanUpgradeDialog from 'components/atoms/modal/FreePlanUpgradeDialog';

const SeoContent = ({
  compareType,
  rank,
  result,
  reason,
  selectFlag,
  title,
  performanceLoading
}) => {
  const dispatch = useDispatch();
  const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);
  const [openkeywordDialog, setOpenKeywordDialog] = useState(false);
  const setting = useSelector(performanceSeoSetting);
  const seodata = useSelector(performanceSeoData);
  const userInfo = useSelector(userinfo);
  const channelName = useSelector(currentchannelName);
  const ownLoading = useSelector(performancereviewOwnDataLoading);
  const otherLoading = useSelector(performancereviewOtherDataLoading);
  const errorMessage = useSelector(errorResMessage);

  const keywordListDict = useSelector(performanceSeokeywordList);
  const otherKeywordList = keywordListDict?.otherKeywordList;
  const ownKeywordList = keywordListDict?.ownKeywordList;
  let keywordList = compareType == 'own' ? ownKeywordList : otherKeywordList;
  const ownKeywordLoading = keywordListDict?.ownLoading;
  const otherKeywordLoading = keywordListDict?.otherLoading;
  let keyword =
    compareType == 'own' ? setting.ownKeyword : setting.otherKeyword;
  // キーワードローディング
  let keywordLoading =
    compareType == 'own' ? ownKeywordLoading : otherKeywordLoading;

  // グラフローディング
  const graphLoading =
    compareType === 'own' ? seodata.own.loading : seodata.other.loading;

  const clickHandler = () => {
    if (!userInfo.plan[channelName].premium && keywordList.length >= 1) {
      setOpenUpgradeDialog(true);
    } else {
      setOpenKeywordDialog(true);
    }
  };
  const handleKeywrodDialogClose = () => {
    setOpenKeywordDialog(false);
  };
  const handleUpgradeDialogClose = () => {
    setOpenUpgradeDialog(false);
  };

  const deleteKeyword = async () => {
    if (
      window.confirm(
        //eslint-disable-line
        'キーワードを削除しますか？※削除されたキーワードのデータは今後蓄積されません'
      )
    ) {
      await dispatch(fetchDeleteSeoKeyword(compareType))
        .then(unwrapResult)
        .then(async () => {
          await dispatch(fetchKeywordList('own'));
          await dispatch(fetchKeywordList('other'));
          dispatch(resetKeyword());
          // ✅ レンダリングが反映されたタイミングで alert
          setTimeout(() => {
            window.alert('キーワード削除が完了しました');
          }, 0);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log('cancel');
    }
  };
  return (
    <>
      <Box
        height="70%"
        width="100%"
        display="flex"
        flexDirection="column"
        gap="26px"
      >
        <Box>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography
                fontWeight="bold"
                fontSize="15px"
                color={compareType == 'own' ? 'text.main' : '#4CAF50'}
              >
                ✓{compareType == 'own' ? '自社' : '競合'}
              </Typography>
            </Box>
            <Box gap={1} display="flex" flexDirection="column" px={2}>
              <Box alignItems="baseline" display="flex">
                <Typography fontWeight="bold" display="inline" flexShrink={0}>
                  掲載順位：
                </Typography>
                <Box
                  display="flex"
                  flex="0 0 auto"
                  alignItems="baseline"
                  justifyContent="center"
                >
                  {selectFlag && keyword === '' ? (
                    <Typography color="text.secondary" lineHeight={1}>
                      キーワードを選択してください
                    </Typography>
                  ) : rank == 0 ? (
                    <Typography
                      color="text.secondary"
                      fontSize="14px"
                      lineHeight={1}
                    >
                      {!selectFlag ? '-' : '圏外'}
                    </Typography>
                  ) : (
                    <>
                      <Typography
                        mr="4px"
                        color="text.secondary"
                        lineHeight={1}
                      >
                        月平均
                      </Typography>
                      <Typography
                        fontWeight="bold"
                        fontSize="20px"
                        lineHeight={1}
                      >
                        {rank}
                      </Typography>
                      <Typography
                        ml="4px"
                        color="text.secondary"
                        lineHeight={1}
                      >
                        位
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
              <Box display="flex">
                {performanceLoading ? (
                  <Box display="flex" alignItems="center">
                    <CircularProgress size={18} thickness={4} />
                  </Box>
                ) : (
                  <>
                    <Typography
                      fontWeight="bold"
                      display="inline"
                      variant="body1"
                      flexShrink={0}
                    >
                      診断結果：
                    </Typography>
                    {(result || result === 0) && result !== '-' ? (
                      result ? (
                        <OKicon
                          sx={{
                            mr: 0,
                            fontSize: '18px',
                            verticalAlign: 'middle'
                          }}
                        />
                      ) : (
                        <NGicon
                          sx={{
                            mr: 0,
                            fontSize: '18px',
                            verticalAlign: 'middle'
                          }}
                        />
                      )
                    ) : (
                      <Typography fontSize="16px" ml={1}>
                        -
                      </Typography>
                    )}
                    <Typography color="text.secondary" display="inline" ml={1}>
                      {reason}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          width="100%"
          minWidth="450px"
          minHeight="450px"
          border={1}
          borderColor="#C3C3C3"
          borderRadius={1}
          justifyContent={
            ownLoading || otherLoading || graphLoading ? 'center' : 'start'
          }
        >
          <>
            <Box
              width="20%"
              borderRight={1}
              borderColor="#C3C3C3"
              display="flex"
              flexDirection="column"
              gap={1}
            >
              {compareType == 'other' && !selectFlag ? null : (
                <>
                  <Typography fontWeight="bold" fontSize="14px">
                    キーワード一覧
                  </Typography>
                  {keywordLoading ? (
                    <Box display="flex" alignItems="center">
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {keywordList?.length == 0 ? (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography>キーワードがありません</Typography>
                        </Box>
                      ) : (
                        <List
                          sx={{
                            width: '100%',
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 300,
                            '& ul': { padding: 0 }
                          }}
                          subheader={<li />}
                        >
                          {keywordList.map((value, index) => {
                            return (
                              <ListItem key={index} disablePadding>
                                <ListItemButton
                                  role={undefined}
                                  onClick={() => {
                                    dispatch(
                                      setKeyword({ value, compareType })
                                    );
                                    dispatch(fetchKeywordGraph(compareType));
                                  }}
                                  dense
                                  sx={{
                                    backgroundColor:
                                      value == keyword ? '#DBEAFE' : '#FFFFFF' // 背景色
                                  }}
                                >
                                  <ListItemText id={index} primary={value} />
                                  {value == keyword && (
                                    <IconButton
                                      sx={{ p: 0 }}
                                      onClick={(event) => {
                                        event.stopPropagation(); // 親要素のテーブルの開閉が起きないようイベントの伝播を停止
                                        deleteKeyword();
                                      }}
                                    >
                                      <DeleteForeverIcon />
                                    </IconButton>
                                  )}
                                </ListItemButton>
                              </ListItem>
                            );
                          })}
                        </List>
                      )}
                      <ResponsiveButton
                        label="キーワード追加"
                        minLabel="追加"
                        width="100px"
                        onClick={clickHandler}
                      />
                    </>
                  )}
                </>
              )}
            </Box>
            <Box width="80%" minHeight="300px">
              {keyword == '' ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <Typography color="text.secondary">
                    {!selectFlag
                      ? '競合商品を選択してください'
                      : 'キーワードを選択してください'}
                  </Typography>
                </Box>
              ) : (
                <>
                  {graphLoading ? (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="100%"
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <SeoCompareLineGraph compareType={compareType} />
                  )}
                </>
              )}
            </Box>
          </>
          {/* )} */}
        </Box>
        {/* </Box> */}
      </Box>
      {/* 無料プランアップグレードダイアログ */}
      <FreePlanUpgradeDialog
        open={openUpgradeDialog}
        onClose={handleUpgradeDialogClose}
        word={'キーワード'}
        page={'seoResultDialog'}
      />
      {/* キーワード追加ダイアログ　*/}
      <SeoKeywordRegisterDialog
        open={openkeywordDialog}
        onClose={handleKeywrodDialogClose}
        title={title}
        compareType={compareType}
      />
    </>
  );
};

export default SeoContent;
